import { Text } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space, fontSizes, fontWeights } = theme

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  svg {
    margin-bottom: ${space['spacing-md']};
  }
`

export const Title = styled(Text)`
  font-size: ${fontSizes['font-size-heading-5']};
  font-weight: ${fontWeights['font-weight-medium']};
  margin-bottom: ${space['spacing-sm']};
`

export const ActionsWrapper = styled.div<{ $layout: 'stack' | 'responsive' }>`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  width: 100%;
  margin-top: ${({ $layout }) => ($layout === 'responsive' ? space['spacing-md'] : space['spacing-xl'])};

  ${({ $layout }) =>
    $layout === 'responsive' &&
    `
    button {
      width: 100%;
      justify-content: center;
    }

    @media screen and (${media.tablet}) {
      flex-direction: row;
      justify-content: flex-end;
    }
  `}
`
